import { useMemo } from "react";
import { useGetIncoTermsQuery } from "shared/api";
import { adaptIncoTermsToOptions } from "shared/adapters";

export const useIncoTermsOptions = () => {
  const { data: incoTerms, isLoading: isLoadingIncoTerms } =
    useGetIncoTermsQuery();

  const incoTermsOptions = useMemo(
    () => adaptIncoTermsToOptions(incoTerms || []),
    [incoTerms]
  );

  return { incoTermsOptions, isLoadingIncoTerms };
};
